
import { Component, Mixins } from "vue-property-decorator";
import { Point, Size, Rectangle } from "../../../../../../../base/domain/drawing";
import { PrintBehaviorPropertyEditableMixin, LineStylePropertyEditableMixin } from "../../../mixins";
import { default as RectangleCoordinatableObjectDrawerBase } from "./RectangleCoordinatableObjectDrawerBase.vue";

@Component
export default class ShapeObjectDrawerBase extends Mixins(RectangleCoordinatableObjectDrawerBase, PrintBehaviorPropertyEditableMixin, LineStylePropertyEditableMixin) {
  get shapeRectangle(): Rectangle {
    return new Rectangle(
      new Point(0, 0),
      new Size(Math.max(this.offsetRectangleCoordinate.size.width, 1), Math.max(this.offsetRectangleCoordinate.size.height, 1)));
  }
}
